<div class="catalog-content">
    <div>
        <app-catalogue-video-form
            [videoData]="activeVideoData"
            [selectedTab]="selectedTab"
            (refreshChange)="onRefreshData($event)"
            (sectionChange)="onSectionChange($event)"
        ></app-catalogue-video-form>
    </div>
    <app-product-video
        [data]="productVideoList"
        (editChange)="onEdit($event)"
        *ngIf="selectedTab==='Products'"
    ></app-product-video>
    <app-investor-video
        [data]="investorVideoList"
        (editChange)="onEdit($event)"
        *ngIf="selectedTab==='Investors'"
    ></app-investor-video>
</div>
